export default {"src":"/_next/static/media/calendar.ee59bda4.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};